import { useEffect, useState } from 'react';
import { useRef } from 'react';
import { useAuth } from '../../../Auth/AuthContext copy';
import EmailField from './inputs/EmailField';
import NameField from './inputs/NameField';
import PasswordField from './inputs/PasswordField';
import SubmitButton from './inputs/SubmitButton';
import ResetPassword from './ResetPassword';
import "./Login.css";
import { Google } from '@mui/icons-material';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';




const Loogin = () =>{
  const nameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();

  const [isRegister, setIsRegister] = useState(false);
  const {
    modal,
    setModal,
    signUp,
    login,
    loginWithGoogle,
    setAlert,
    setLoading,
  } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    if (isRegister) {
      const confirmPassword = confirmPasswordRef.current.value;
      const username=nameRef.current.value
      try {
        if (password !== confirmPassword) {
          throw new Error("Passwords don't match");
        }
        await signUp(email, password,username);
        setModal({ ...modal, isOpen: false });
      } catch (error) {
        setAlert({
          isAlert: true,
          severity: 'error',
          message: error.message,
          timeout: 5000,
          location: 'modal',
        });
        console.log(error);
      }
    } else {
      try {
        await login(email, password);
        setModal({ ...modal, isOpen: false });
      } catch (error) {
        setAlert({
          isAlert: true,
          severity: 'error',
          message: error.message,
          timeout: 5000,
          location: 'modal',
        });
        console.log(error);
      }
    }
    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    try {
      await loginWithGoogle();
      setModal({ ...modal, isOpen: false });
    } catch (error) {
      setAlert({
        isAlert: true,
        severity: 'error',
        message: error.message,
        timeout: 5000,
        location: 'modal',
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (isRegister) {
      setModal({ ...modal, title: 'Register' });
    } else {
      setModal({ ...modal, title: 'Login' });
    }
  }, [isRegister]);
  return (
    <>
      <form onSubmit={handleSubmit}>
        <DialogContent >
          {/* <DialogContentText>
          {isRegister
          ? 'Complete your Details'
          : "Login with your Email Password"}
            
          </DialogContentText> */}
          {isRegister && (
            <NameField  {...{ nameRef }} />
          )}
          <EmailField {...{ emailRef }} />
          <PasswordField {...{ passwordRef, autoFocus: false }} />
          {isRegister && (
            <PasswordField
              {...{
                passwordRef: confirmPasswordRef,
                id: 'confirmPassword',
                label: 'Confirm Password',
                autoFocus: false,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ width: '92%', py: '0', minHeight: 'auto' }}>
          <Button
             size="small"
             sx={{
               color: '#777', // Default color
               fontFamily: '"Jost", sans-serif', // Custom font
               textTransform: 'none', // Prevent uppercase
               '&:hover': {
                 color: '#1976d2', // Change text color on hover
                 backgroundColor: 'transparent', // Prevent background highlight
               },
             }}
            onClick={() =>
              setModal({
                ...modal,
                title: 'Reset Password',
                content: <ResetPassword />,
              })
            }
          >
            Forgot Password?
          </Button>
        </DialogActions>
        <SubmitButton isRegister={isRegister} />
      </form>
      <DialogActions sx={{ justifyContent: 'left', p: '5px 24px' }}>
        {isRegister
          ? 'Do you have an account? Login in now'
          : "Don't you have an account? Create one now"}
        <Button size="small"
             sx={{
               color: 'black', // Default color
               fontFamily: '"Jost", sans-serif',
               fontWeight: 'bold', 
               textTransform: 'none', // Prevent uppercase
               '&:hover': {
                 color: '#1976d2', // Change text color on hover
                 backgroundColor: 'transparent', // Prevent background highlight
               },
             }} onClick={() => setIsRegister(!isRegister)}>
          {isRegister ? 'Login' : 'Register'}
        </Button>
      </DialogActions>
      <DialogActions sx={{justifyContent: 'center', py: '24px' }}>
      <Button
    variant="outlined"
    startIcon={
      <Google 
        sx={{ 
          color: '#EA4335', // Default to red, but real logo is multi-colored
          fontSize: 24, // Make it slightly larger
        }} 
      />
    }
    sx={{
      color: '#000', // Black text
      borderColor: '#DADCE0', // Light gray border
      fontWeight: 'bold',
      textTransform: 'none', // Keep normal case
      fontFamily: '"Roboto", sans-serif', // Google font
      borderRadius: '24px', // Rounded edges
      padding: '8px 16px', // Adjust padding
      minWidth: '220px', // Adjust button width
      '&:hover': {
        backgroundColor: '#F8F9FA', // Light hover effect
        borderColor: '#DADCE0',
      },
    }}
    onClick={handleGoogleLogin}
  >
    Sign in with Google
  </Button>
      </DialogActions>
    </>
  );
}

export default Loogin;
